import {mapActions, mapGetters, mapMutations} from 'vuex'
import ticketEvent from '@/store/modules/call/ticketEvent'
import Helpers from '@/util/helpers'
import apiEvent from '@/util/call/apiEvent'
import { netDialApi } from '@/util/call/netDialAPI'
import { klCnsAPI } from '@/util/call/klCnsAPI'
import { store } from '../../../store/store'

const callEvent = {
  data () {
    return {
      brandId: '',
      serviceList: [],
      callRepresentativeNumber: '',
      isWorkNotReadyStart: false,
      checkWorking: false,
      setTimeoutVal: null,
      callClearCount: 0,
      callType: {
        KT: 'KT_CALL',
        NEOMECCA: 'CALL'
      }
    }
  },
  computed: {
    ...mapGetters([
      'callLoginId',
      'callBrandId',
      'telNumber',
      'enabledCallAgent',
      'isExistCallAgent',
      'currentBrandId',
      'agentMappingBrandViews',
      'customerPhoneNumber',
      'btnStatus',
      'callInfo',
      'callUserKey',
      'loginId',
      'isLoggedIn',
      'callMode'
    ])
  },
  watch: {
    callInfo: {
      deep: true,
      handler: function () {
        if (this.isLoggedIn) {
          this.changeCallInfo()
        }
      }
    },
    loginId (newVal) {
      if (Helpers.isStringValid(newVal) && !this.$targetMake.isSeller) {
        this.initialize()
      } else {
        this.$eventBus.$off('set-call-agent')
        this.$eventBus.$off('call-error')
        this.$eventBus.$off('websocket-disconnect')
        this.$eventBus.$off('call-connection')
        this.$eventBus.$off('call-bound:in')
        this.$eventBus.$off('call-bound:out')
        this.$eventBus.$off('call-send-ticket-event')
        this.$eventBus.$off('select-reservation')
        this.$eventBus.$off('call-work-not-ready')
      }
    },
    currentBrandId (newVal) {
      if (Number.isInteger(newVal)) {
        this.checkUseCall()
      }
    }
  },
  methods: {
    ...mapActions([
      'initLocalStorage',
      'changeCallUserKey'
    ]),
    ...mapMutations([
      'changeEndTime',
      'changeIsClose',
      'changeCallAgentStatus',
      'changeIsSummaryCompleted',
      'changeCallBackInfo',
      'changeTicketId',
      'changeDnis',
      'changeBrandDnis',
      'changeServiceCode',
      'changeIncomingChannel',
      'changeCallInfo',
      'changeIsOriginatedEnd',
      'changeIsCleared',
      'changeCallEnd',
      'FAIL_CALL_CONNECT'
    ]),
    initialize () {
      this.brandId = this.agentMappingBrandViews.sort((left, right) => left.brandId - right.brandId)[0].brandId
      this.checkUseCall()
      this.$eventBus.$on('set-call-agent', () => {
        this.initLocalStorage()

        if (this.enabledCallAgent && this.isExistCallAgent) {
          this.fetchServiceList()
          this.$eventBus.$off('call-error')
          this.$eventBus.$off('websocket-disconnect')
          this.$eventBus.$off('call-connection')
          this.$eventBus.$off('call-bound:in')
          this.$eventBus.$off('call-bound:out')
          this.$eventBus.$off('call-send-ticket-event')
          this.$eventBus.$off('select-reservation')
          this.$eventBus.$off('call-work-not-ready')

          this.$eventBus.$on('call-error', (msg) => {
            this.errorDialog(msg)
            this.$logReport.write(`[EVENT-BUS]ON - ERROR:${msg}`)
          })
          this.$eventBus.$on('websocket-disconnect', () => {
            if (store.getters.callMode !== 'KT') { this.webSocketErrorDialog() }
          })
          this.$eventBus.$on('call-connection', (text) => {
            if (store.getters.callMode !== 'KT') {
              this.$logReport.write(`[EVENT-BUS]ON - CONNECTION:${text}`)
              if (text === 'originated') {
                this.changeCallEnd(true)
                this.$logReport.write(`[CHANGE-AGENT]通話中`)
                this.changeCallAgentStatus('通話中')
                this.$eventBus.$emit('user-status-change', '相談中')
                this.changeIsSummaryCompleted(false)
                this.isWorkNotReadyStart = false
                this.checkWorking = true
              } else if (text === 'cleared') {
                this.changeIsCleared(true)
                if (this.callInfo.isOriginatedEnd || !this.checkWorking) {
                  if (!this.checkWorking) {
                    this.changeIsSummaryCompleted(false)
                    this.isWorkNotReadyStart = false
                    store.commit('changeCallUserKey', Helpers.inCommingPhoneCovert(this.customerPhoneNumber))
                    this.setOutboundCall({UserInfo: null})
                    this.sendCallTicketEvent(ticketEvent.CG_CALL_APP_OUTGOING)
                  }
                  this.callClear()
                }
              } else if (text === 'originated-completed') {
                this.changeIsOriginatedEnd(true)
                if (this.callInfo.isCleared) this.callClear()
              }
            } else {
              if (text === 'originated') {
                this.changeCallEnd(true)
                this.changeCallAgentStatus('通話中')
                this.$eventBus.$emit('user-status-change', '相談中')
                this.changeIsSummaryCompleted(false)
                this.isWorkNotReadyStart = false
                this.checkWorking = true
              } else if (text === 'cleared') {
                this.changeIsCleared(true)
                if (this.callInfo.isOriginatedEnd || !this.checkWorking) {
                  if (!this.checkWorking) {
                    this.changeIsSummaryCompleted(false)
                    this.isWorkNotReadyStart = false
                    store.commit('changeCallUserKey', Helpers.inCommingPhoneCovert(this.customerPhoneNumber))
                    this.setOutboundCall({UserInfo: null})
                  }
                  this.callClear()
                }
              } else if (text === 'originated-completed') {
                this.changeIsOriginatedEnd(true)
                if (this.callInfo.isCleared) this.callClear()
              }
            }
          })
          this.$eventBus.$on('call-bound:in', (item) => {
            if (store.getters.callMode !== 'KT') {
              this.$logReport.write(`[EVENT-BUS]ON - INBOUND:${item.CallID}`)
              this.inboundAlert(item)
              this.setInboundCall(item)
            } else {
              const phoneNumber = JSON.parse(item).cid
              this.inboundAlertKT(phoneNumber)
              this.setInboundCall(item)
            }
          })
          this.$eventBus.$on('call-bound:out', (item) => {
            if (store.getters.callMode !== 'KT') {
              this.$logReport.write(`[EVENT-BUS]ON - OUTBOUND:${item.CallID}`)
              this.setOutboundCall(item)
            } else {
              this.setOutboundCall(item)
            }
          })
          this.$eventBus.$on('call-send-ticket-event', (val) => {
            setTimeout(() => {
              this.sendCallTicketEvent(val)
            }, 100)
          })
          this.$eventBus.$on('select-reservation', (item) => {
            this.setReserveCall(item)
          })
          this.$eventBus.$on('call-work-not-ready', () => {
            this.callWorkNotReady()
          })
        }
      })
    },
    callClear () {
      if (this.callClearCount > 5) {
        // this.changeCallAgentStatus('후처리중')
        // this.changeIsClose(true)
        // this.changeEndTime(new Date().getTime())
        // this.changeIsOriginatedEnd(false)
        // this.changeIsCleared(false)
        this.callClearCount = 0
        this.FAIL_CALL_CONNECT()
        return
      }

      if (this.callMode !== 'KT') {
        apiEvent.setAgentState('AM_WORK_NOT_READY', this.callLoginId)
      }

      if (!this.isWorkNotReadyStart || !this.checkWorking) {
        if (this.callMode !== 'KT') {
          this.$logReport.write(`[CHANGE-AGENT]後処理中`)
        }
        this.changeCallAgentStatus('後処理中')
        this.changeIsClose(true)
        this.changeEndTime(new Date().getTime())
        this.changeIsOriginatedEnd(false)
        this.changeIsCleared(false)
      }
      this.checkWorking = false
      this.isWorkNotReadyStart = true
      this.callClearCount++
      this.setTimeoutVal = setTimeout(() => this.callClear(), 1000)
    },
    callWorkNotReady () {
      if (this.setTimeoutVal) {
        clearTimeout(this.setTimeoutVal)
      }
      if (!this.isWorkNotReadyStart) {
        return
      }
      this.callClearCount = 0
      this.isWorkNotReadyStart = false
    },
    fetchServiceList () {
      if (store.getters.callMode !== 'KT') {
        this.axios.get(`/gateway/call/brand/listSub/${this.callBrandId}`)
          .then(result => {
            if (result.data.code === 0) {
              const data = result.data.data
              this.serviceList = data.map(item => {
                return {calledNumber: item.rmk, representativeNumber: item.rmk2, name: item.codeNm}
              })
            } else {
              this.$toasted.error(result.data.message)
            }
          })
      } else {
        const currentBrandId = this.currentBrandId || this.agentMappingBrandViews.sort((left, right) => left.brandId - right.brandId)[0].brandId
        this.$http
          .get(`/api/brand/${currentBrandId}/callserviceinfo`)
          .then(result => {
            if (result.data.code === 0) {
              const data = result.data.data
              this.serviceList = data.map(item => {
                return {calledNumber: item.serviceNumber, representativeNumber: item.serviceNumber, name: item.serviceName}
              })
            } else {
              this.$toasted.error(result.data.message)
            }
          }).catch(err => this.$toasted.error(err))
      }
    },
    checkUseCall () {
      this.axios.get('/api/brand/isUsableModuleChannel', {
        params: {
          brandId: this.currentBrandId || this.brandId,
          moduleName: 'CALL',
          channelName: this.callType[this.callMode]
        }
      }).then(result => {
        if (result.data.code === 0) {
          this.fetchModuleData()
          if (store.getters.callMode !== 'KT') { this.$logReport.create() }
        }
      })
    },
    fetchModuleData () {
      this.axios.get('/api/brand/searchChannelData', {
        params: {
          brandId: this.currentBrandId || this.brandId,
          moduleName: 'CALL',
          channelName: this.callType[this.callMode]
        }
      }).then(result => {
        if (result.data.code === 0) {
          const data = result.data.data
          this.callRepresentativeNumber = data.callRepresentativeNumber
        } else {
          this.$toasted.error(result.data.message)
        }
      })
    },
    setReserveCall (item) {
      if (store.getters.callMode !== 'KT') {
        const service = this.serviceList.find(service => service.calledNumber === item.dnis)
        if (Helpers.isObjectValid(service)) {
          this.changeCallUserKey(item.callPhone)
          this.changeCallBackInfo({callbackId: item.callbackId, callbackType: item.callbackType})
          this.changeTicketId(item.ticketId)
          this.makeOutCall(service.representativeNumber)
        }
      } else {
        const service = this.serviceList.find(service => service.calledNumber === item.serviceNumber)
        if (Helpers.isObjectValid(service)) {
          this.changeCallUserKey(item.customerNumber)
          this.changeCallBackInfo({callbackId: item.id, callbackType: item.type})
          this.changeTicketId(item.ticketId)
          this.makeOutCall(service.representativeNumber, item.serviceNumber)
        }
      }
    },
    makeOutCall (brandNumber, serviceNumber) {
      const customerNumber = Helpers.outCommingPhoneCovert(this.callInfo.userKey)
      store.getters.callMode !== 'KT' ? netDialApi.ndMakeCall(customerNumber, brandNumber, 0) : klCnsAPI.KlExternalCall(customerNumber.slice(1), serviceNumber)
    },
    errorDialog (msg) {
      this.$eventBus.$emit('DialogPopup', {
        useDialog: true,
        messageHTML: '<dl class="txt"><dt>CALL エラー発生: ' + msg + '</dt><dd>管理者にお問い合わせください。</dd></dl>',
        getBtnCount: 1
      })
    },
    webSocketErrorDialog () {
      this.$eventBus.$emit('DialogPopup', {
        useDialog: true,
        messageHTML: '<dl class="txt"><dt>Call サーバーとの接続が切断されました。<br/>更新してください。 </dd></dl>',
        getBtnCount: 1
      })
    },
    inboundAlert (item) {
      if (this.$route.path !== '/call/operation') {
        this.$toasted.success(
          `<div className="callNoticeToast callIcon"> <dl className="successIcon"> <dt>電話が <strong>受信中</strong> です。</dt> <dd className="data">${this.$moment().format('MM.DD')} <span>${this.$moment().format('HH:mm')}</span></dd> </dl></div>`, {
            position: 'top-right',
            duration: 10000
          })
      }

      let callingDn = Helpers.phoneRegExp(item.Calling_dn)
      if (item.Calling_dn.includes('anonymous')) {
        callingDn = '発信番号の表示制限 '
      }

      if (Notification.permission !== 'granted') {
        console.log('notification is disabled')
      } else {
        let notification = new Notification('着信通知', {
          icon: `https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/outaigate_alram.png`,
          body: callingDn + '受信中です。',
          requireInteraction: true
        })

        notification.error = function () {
          console.log('notification error')
        }
      }
    },
    inboundAlertKT (phoneNumber) {
      if (this.$route.path !== '/call/operation') {
        this.$toasted.success(
          `<div className="callNoticeToast callIcon"> <dl className="successIcon"> <dt>電話が <strong>受信中</strong> です。</dt> <dd className="data">${this.$moment().format('MM.DD')} <span>${this.$moment().format('HH:mm')}</span></dd> </dl></div>`, {
            position: 'top-right',
            duration: 10000
          })
      }

      if (Notification.permission !== 'granted') {
        console.log('notification is disabled')
      } else {
        let notification = new Notification('着信通知', {
          icon: `https://public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/outaigate_alram.png`,
          body: phoneNumber + '受信中です。',
          requireInteraction: true
        })

        notification.error = function () {
          console.log('notification error')
        }
      }
    },
    setInboundCall (item) {
      if (store.getters.callMode !== 'KT') {
        /* UserInfo 파싱한 값 === Calling_dn이 같거나
         Redirection_dn 값이 없을 때 일반적인 IB 콜
         Redirection_dn 값이 있으면 협의로 들어온 IB 콜
         */
        if (Helpers.isStringValid(item.Redirection_dn)) { // 협의
          const data = JSON.parse(item.UserInfo)
          this.changeCallUserKey(data.phoneNumber)
          this.changeServiceCode(data.serviceCode)
          this.changeDnis(data.dnis)
          // 협의 메모 > data.memo
        } else { // 일반 IB
          this.changeServiceCode(item.UserInfo.substr(34, 4))
          this.changeDnis(item.UserInfo.substr(38, 11))
          if (item.UserInfo.substr(98, 20) !== 'undefined' && item.UserInfo.substr(98, 20).trim()) {
            this.changeTicketId(item.UserInfo.substr(98, 20).trim())
          }
        }

        this.changeIncomingChannel(this.callInfo.serviceCode ? 'IN' : 'OUT')

        let service = this.serviceList.find(item => item.calledNumber === this.callInfo.dnis)
        if (Helpers.isObjectValid(service)) {
          this.changeBrandDnis(service.representativeNumber)
        }
      } else {
        if (item) {
          const itemObj = JSON.parse(item)
          const phoneNumber = itemObj.cid
          const dnis = itemObj.rid
          const serviceCode = ticketEvent.CG_CALL_APP_INCOMMING

          this.changeCallUserKey(phoneNumber)
          this.changeServiceCode(serviceCode)
          this.changeDnis(dnis)

          this.changeIncomingChannel('IN')

          let service = this.serviceList.find(item => item.calledNumber.split('-').join('') === dnis)
          if (Helpers.isObjectValid(service)) {
            this.changeBrandDnis(service.representativeNumber.split('-').join(''))
          }
        }
      }
    },
    setOutboundCall (item) {
      this.changeIncomingChannel('OUT')
      if (this.callMode !== 'KT') {
        this.changeBrandDnis(item.UserInfo || this.callRepresentativeNumber)

        let service = this.serviceList.find(item => item.representativeNumber === this.callInfo.brandDnis)
        if (Helpers.isObjectValid(service)) {
          this.changeDnis(service.calledNumber)
        }
      }
    },
    sendCallTicketEvent (eventCode) {
      this.axios.post('/gateway/ticket/sendTicketEvent', {
        ticketId: this.callInfo.ticketId || null,
        eventCode: eventCode,
        applicationName: 'CTI',
        agentInfo: {
          id: this.callLoginId
        },
        brandInfo: {
          id: this.callInfo.brandDnis || this.callRepresentativeNumber
        },
        customerInfo: {
          // name: this.customerInfo.name,
          callKey: this.callInfo.userKey
        },
        data: {
          callRecNo: this.callInfo.recordNo
        }
      }).then(res => {
        if (res.data.code === 0) {
          const data = res.data.data
          if (data && data.ticketId) {
            this.changeTicketId(data.ticketId)
          }
        } else {
          this.$toasted.error(res.data.message)
        }
      })
    }
  }
}

export default callEvent



// WEBPACK FOOTER //
// ./src/components/mixin/call/callEvent.js